/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropType from 'prop-types';
import { SVGIcon } from '@custom-components';
import { StyledIconSizing, StyledIconContainer } from './PortalSVGIcon.styles';

/** Icon imports */
import Dashboard from './icons/Dashboard';
import Bookings from './icons/Bookings';
import Customers from './icons/Customers';
import Suppliers from './icons/Suppliers';
import Margins from './icons/Margins';
import Users from './icons/Users';
import Accounting from './icons/Accounting';
import Tickets from './icons/Tickets';
import VCCs from './icons/VCCs';

import PlatformManagement from './icons/PlatformManagement';
import Help from './icons/Help';
import FeatureFlags from './icons/FeatureFlags';
import Approvals from './icons/Approvals';
import Connections from './icons/Connections';
import ConnectionManagement from './icons/ConnectionManagement';
import RoleManagement from './icons/RoleManagement';
import CopyToClipboard from './icons/CopyToClipboard';

/** Add SVG Icons here */
const iconIndex = (props) => ({
  dashboard: <Dashboard {...props} />,
  bookings: <Bookings {...props} />,
  customers: <Customers {...props} />,
  suppliers: <Suppliers {...props} />,
  margins: <Margins {...props} />,
  users: <Users {...props} />,
  accounting: <Accounting {...props} />,
  tickets: <Tickets {...props} />,
  vccs: <VCCs {...props} />,

  'platform-management': <PlatformManagement {...props} />,
  help: <Help {...props} />,
  approvals: <Approvals {...props} />,
  connections: <Connections {...props} />,
  hotel: <SVGIcon selectedIcon="hotel" {...props} />,
  'connection-management': <ConnectionManagement {...props} />,
  'role-management': <RoleManagement {...props} />,
  featureFlags: <FeatureFlags {...props} />,
  'copy-to-clipboard': <CopyToClipboard {...props} />
});

export const iconIndexKeys = Object.keys(iconIndex(null));

function PortalSVGIcon(props) {
  const { selectedIcon, height, width, rotate, className, onClick, ...rest } = props;
  const icon = iconIndex(rest)[selectedIcon];

  let iconWidth;
  let iconHeight;
  let iconPadding;
  if (icon) {
    iconPadding =
      (icon.props.width && icon.props.height) !== undefined ? (icon.props.height / icon.props.width) * 100 : 100;
    iconWidth = icon.props.width !== undefined ? `${icon.props.width}px` : '';
    iconHeight = icon.props.height !== undefined ? `${icon.props.height}px` : '';
  }

  // overrides the icon padding based on the passed props for height and width if both are passed.
  if (height && width) iconPadding = (height.replace('px', '') / width.replace('px', '')) * 100;

  // overrides the height to auto if a percent is passed to the width
  const heightAuto = width ? width.indexOf('%') > -1 : false;

  return (
    <StyledIconSizing
      width={!width ? `${iconWidth}` : width}
      height={!height ? `${iconHeight}` : height}
      className={className}
      heightAuto={heightAuto}
      onClick={onClick}
    >
      <StyledIconContainer rotate={rotate} iconPadding={iconPadding}>
        {icon || null}
      </StyledIconContainer>
    </StyledIconSizing>
  );
}

PortalSVGIcon.propTypes = {
  /**
   * The Selected SVG Icon
   */
  selectedIcon: PropType.string.isRequired,

  /**
   * Selected background color, all SVGs have a default color related to their branding
   */
  backgroundColor: PropType.string,

  /**
   * The height of the Icon if different from the default - including unit (px, % etc.)
   */
  height: PropType.string,

  /**
   * The width of the Icon if different from the default - including unit (px, % etc.)
   */
  width: PropType.string,

  /**
   * The Icons color, most default to white
   */
  iconColor: PropType.string,

  /**
   * Rotation of the Icon, passed as a number between 0-360
   */
  rotate: PropType.number,

  /**
   * Option to take in a click function on the SVG
   */
  onClick: PropType.func,
  /**
   * Add ability to override in .styles.js file
   */
  className: PropType.string
};

PortalSVGIcon.defaultProps = {
  backgroundColor: undefined,
  height: undefined,
  width: undefined,
  iconColor: undefined,
  rotate: 0,
  onClick: undefined,
  className: null
};

export default PortalSVGIcon;
